export const cercaObj = {
  tilesIcon: require('../../images/tiles.png'),
  closeIcon: require('../../images/close.png')
};
